import React from "react";
import { Helmet } from "react-helmet";
import { Default } from "../layouts/default";
import "../../css/RefundCancellationPolicy.css";
import { Link } from "react-router-dom";

const RefundCancellationPolicy = () => {
  return (
    <Default>
      <>
        <Helmet>
          <title>Refund & Cancellation Policy | BookVenue</title>
          <meta
            name="description"
            content="Check BookVenue refund and cancellation policy for sports venue bookings, including cricket grounds, football turfs, and courts."
          />
        </Helmet>
        <section className="policy-page refund-page">
          <div className="bv-container">
            <div className="policy-shell">
              <div className="policy-header">
                <span className="policy-eyebrow">Booking Support</span>
                <h1 className="policy-title">Refund & Cancellation Policy</h1>
                <p className="policy-subtitle">
                  BookVenue provides an easy way to book sports venues online, but
                  we understand that plans can change.
                </p>
              </div>

              <div className="policy-content">
            {/* <p className="effective-date">
          <strong>Effective Date:</strong> [Add Date]
        </p> */}

            <p className="intro-text">
              BookVenue provides an easy way to book sports venues online, but
              we understand that plans can change.
            </p>

            <section className="policy-section">
              <h2>Cancellation Policy</h2>
              <ul className="steps">
                <li>Cancellation rules depend on the individual venue</li>
                <li>
                  Some venues allow free cancellation within a specific time
                </li>
                <li>Late cancellations may not be eligible for a refund</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>Refund Policy</h2>
              <ul className="steps">
                <li>Refunds will be processed within 5–10 business days</li>
                <li>
                  The amount will be credited to the original payment method
                </li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>No-Show Policy</h2>
              <ul className="steps">
                <li>If the user does not show up, no refund may be provided</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>Important Note</h2>
              <p>
                Each venue may have its own cancellation and refund rules.
                Please review before booking.
              </p>
            </section>

            <section className="policy-section support-section">
              <h2>Support</h2>
              <p>
                For any queries, email:{" "}
                <Link to="mailto:admin@bookvenue.app">admin@bookvenue.app</Link>
              </p>
            </section>
              </div>
            </div>
          </div>
        </section>
      </>
    </Default>
  );
};

export default RefundCancellationPolicy;
